export default function getModuleApiServiceName(entityName: string) {
  return (
    entityName.charAt(0).toUpperCase() +
    entityName.slice(1) +
    'ModuleApiService'
  );
}
